import { render } from "./PersonIntroView.vue?vue&type=template&id=34b26ae8&scoped=true"
import script from "./PersonIntroView.vue?vue&type=script&lang=js"
export * from "./PersonIntroView.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/personintro.css?vue&type=style&index=1&id=34b26ae8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b26ae8"]])

export default __exports__